export interface FetchierOptions extends RequestInit {
    timeout?: number;
}

export async function fetchWithTimeout(
    resource: RequestInfo,
    options: FetchierOptions = {}
): Promise<Response> {
    const { timeout = 8000, ...fetchOptions } = options;

    const controller = new AbortController();
    const id = setTimeout(() => controller.abort(), timeout);

    try {
        const response = await fetch(resource, {
            ...fetchOptions,
            signal: controller.signal,
        });
        clearTimeout(id);
        return response;
    } catch (error) {
        clearTimeout(id);
        throw error;
    }
}
